var site = site || {};
var generic = generic || {};

(function ($) {
  'use strict';

  Drupal.behaviors.productKitFormatterV1 = {
    attach: function (context) {
      var $kitContainer = $('.js-product-kit-wrapper', context);
      var $largeThumb = $('.js-kit-large-thumb', $kitContainer);
      var $smallThumb = $('.js-kit-small-thumb', $kitContainer);
      var $menuTrigger = $('.js-collapsible-menu-trigger', $kitContainer);
      var $addToSet = $('.js-product-kit-button', $kitContainer);
      var $imageTrigger = $('.js-kit-img-container', $kitContainer);
      var $menuHeader = $('.js-collapsible-menu-parent', $kitContainer);
      var kitCategoryLength = $menuHeader.length;
      var $changeProduct = $('.js-kit-edit', $kitContainer);
      var $selectedThumbImg = $('.js-kit-thumb-image', $kitContainer);
      var selectedSkuIds = [];
      var $stickyImg = $('.js-sticky-kit-image', $kitContainer);
      var $kitTransparent = $('.js-kit-transparent', $kitContainer);
      var $collapsibleSubMenu = $('.js-collapsible-sub-menu', $kitContainer);
      var $addToBag = $('.js-add-to-kit', $kitContainer);
      var $editProdImage = $('.js-review-product-image', $kitContainer);
      var $selectedProdSmall = $('.js-selected-products-small', $kitContainer);
      var offerDetails = {};
      let catSoldOut = false;
      let oosCount = 0;
      var $kitSku,
        invStatus,
        $menuParent,
        $menuParentImg,
        $menuParentBtn,
        $menuChild,
        $prodThumb,
        $menuSelect,
        $selectElement,
        catagoryIndex;
      var $selectedImage,
        $activeProduct,
        $selectedAddToset,
        imagePath,
        prodNameData,
        prodDescData,
        isInventory,
        $menuTitle,
        data,
        productKitImageTempate;
      var skuBaseId,
        $menuNext,
        thumbPath,
        $collapsibleMenuIndex,
        $selectedItem,
        args,
        resultData,
        $menuElement;
      var $addToSetElement,
        $editElement,
        $kitItemElement,
        $itemElement,
        $selectedItemElem,
        $addToSetItem,
        addToSetCopy;
      var $document = $(document);
      var $body = $('body');
      var $defaultImage = $('.js-kit-sold-out-image', $kitContainer);
      var $dynamicPricing = $('.js-update-dynamic-pricing', $kitContainer);
      var $dynamicDiscountPricing = $('.js-update-dynamic-discount-pricing', $kitContainer);
      var currencySymbol = $kitContainer.data('currency-symbol');
      var kitName = $kitContainer.data('kit-name');
      var offerCode = $kitContainer.data('offer-code');
      var defaultSku = $kitContainer.data('default-sku');
      var $multiSelectedSkus = [];
      var productOutOfStock = 2;
      var productSoldOut = 7;

      $body.addClass('page-product');

      // Validate sold-out/oos for kit SKU's
      $menuHeader.removeClass('cat-sold-out');
      $menuHeader.each(function (index, item) {
        $itemElement = $(item);
        $kitSku = $itemElement.find('.js-kit-img-container');
        oosCount = 0;
        $kitSku.each(function (num, kitItem) {
          $kitItemElement = $(kitItem);
          invStatus = parseInt($kitItemElement.attr('data-inventory'));
          if (invStatus === productOutOfStock || invStatus === productSoldOut || !invStatus) {
            oosCount = oosCount + 1;
            $kitItemElement.addClass('in-active');
          }
        });

        if (oosCount !== 0 && oosCount === $kitSku.length) {
          $kitTransparent.addClass('active');
          $addToBag.addClass('button--inactive');
          catSoldOut = true;
          return true;
        }
      });

      $body.addClass('custom-kit-page');
      $menuTrigger.on('click', function () {
        $menuElement = $(this);
        $menuParent = $menuElement.parent($menuHeader);
        $menuChild = $menuParent.find($collapsibleSubMenu);
        $prodThumb = $menuParent.find($imageTrigger).not('.in-active');
        $menuSelect = $menuChild.find('.selected');
        $selectElement = $menuSelect.length > 0 ? $menuSelect : $prodThumb.first();
        $menuHeader.not($menuParent).removeClass('collapsible-menu__parent--expanded');
        if (!$menuParent.hasClass('collapsible-menu__parent--expanded')) {
          return;
        }
        if (!$menuElement.hasClass('active')) {
          $selectElement.trigger('click', true);
          $menuTrigger.removeClass('active');
          $menuElement.addClass('active');
        }
      });
      $('.js-pricing-list', $kitContainer).removeClass('hidden');

      $imageTrigger.on('click', function (event, select) {
        $selectedImage = $(this);
        $menuParentImg = $selectedImage.parents('.js-collapsible-menu-parent');
        $activeProduct = $menuParentImg.find('.active-product');
        $selectedAddToset = $menuParentImg.find('.js-product-kit-button');
        imagePath = $selectedImage.attr('data-large-img');
        prodNameData = $selectedImage.attr('data-name');
        prodDescData = $selectedImage.attr('data-short-desc');
        isInventory = parseInt($selectedImage.attr('data-inventory'));
        $addToSetItem = $selectedAddToset.find('.add-to-set');
        addToSetCopy = $addToSetItem.attr('data-add-to-set');
        $menuTitle = $menuParentImg.find($menuTrigger);

        // Set State of SKU
        $selectedAddToset.removeClass('in-active');
        if (isInventory === productOutOfStock || isInventory === productSoldOut || !isInventory) {
          $selectedAddToset.addClass('in-active');
        }

        $addToSetItem.html(addToSetCopy);

        // Thumb Animation
        if (!$selectedImage.hasClass('active-product') || select) {
          $largeThumb
            .fadeTo('slow', 0, 'linear', function () {
              data = {};
              data.LARGE_IMAGE = imagePath;
              data.PROD_RGN_NAME = prodNameData;
              data.SHORT_DESC = prodDescData;
              productKitImageTempate = site.template.get({
                name: 'product_kit_image',
                data: data
              });
              $largeThumb.html(productKitImageTempate);
              $smallThumb.html(productKitImageTempate);
            })
            .fadeTo('fast', 1, 'linear');
        }

        if (!select) {
          $menuParentImg.removeClass('active-cat');
          catagoryIndex = $menuParentImg.index();
          // Reset SKU image and Add to bag
          $selectedThumbImg.eq(catagoryIndex).attr('src', '').parent().removeClass('active');
          $stickyImg.eq(catagoryIndex).attr('src', '').parent().removeClass('active');
          $activeProduct.removeClass('active-product').removeClass('selected js-kit-selected');
          $selectedImage.addClass('active-product');
          if (!$addToBag.hasClass('button--disabled')) {
            $addToBag.addClass('button--disabled');
            $selectedProdSmall.removeClass('active');
          }
        } else {
          $activeProduct.removeClass('active-product');
          $selectedImage.addClass('active-product');
        }
      });

      function calculateDiscountPrice(price) {
        var offers = offerDetails.offers;
        let percentDiscountedPrice = 0;
        let flatDiscountedPrice = 0;
        let discountedPrice = 0;
        let discountValue = 0;

        if (offers && offers[offerCode]) {
          var bundleOffer = offers[offerCode];

          $.each(bundleOffer.benefits, function (index, benefit) {
            if (benefit.class === 'PercentDiscount') {
              percentDiscountedPrice = (price * benefit.value) / 100;
            } else if (benefit.class === 'FlatDiscount') {
              flatDiscountedPrice = benefit.value;
            }
          });
          discountValue = flatDiscountedPrice;
          if (percentDiscountedPrice > flatDiscountedPrice) {
            discountValue = percentDiscountedPrice;
          }
          discountedPrice = price - discountValue;
          $dynamicDiscountPricing.html(currencySymbol + discountedPrice.toFixed(2));
          $dynamicPricing
            .addClass('product-sku-price2__value')
            .html(currencySymbol + price.toFixed(2));
        }
      }

      function updatePrice() {
        let totalPrice = 0;

        if ($multiSelectedSkus.length > 0) {
          $.each($multiSelectedSkus, function (index, value) {
            if (value !== undefined) {
              totalPrice += value;
            }
          });
          $dynamicPricing.html(currencySymbol + totalPrice.toFixed(2));
          calculateDiscountPrice(totalPrice);
        }
      }

      function fetchOffers(offCode) {
        generic.jsonrpc.fetch({
          method: 'offers.getOffersRpcData',
          params: [
            {
              offers: offCode
            }
          ],
          onSuccess: function (jsonRpcResponse) {
            var response = jsonRpcResponse.getValue();

            if (typeof response !== 'undefined') {
              offerDetails.offers = response.offers;
            }
          }
        });
      }
      if (offerCode !== undefined && offerCode !== '') {
        fetchOffers(offerCode);
      }
      // When click event is triggered on 'add to set' button, the thumbnail of the product will display over the 'selected-products' div
      $addToSet.on('click', function () {
        $addToSetElement = $(this);
        if ($addToSetElement.hasClass('in-active')) {
          return;
        }
        $addToBag.addClass('button--disabled');
        $selectedProdSmall.removeClass('active');
        $menuParentBtn = $addToSetElement.parents('.js-collapsible-menu-parent');
        $activeProduct = $menuParentBtn.find('.active-product');
        catagoryIndex = $menuParentBtn.index();
        skuBaseId = $activeProduct.attr('data-sku-base-id');
        $multiSelectedSkus[catagoryIndex] = parseInt($activeProduct.attr('data-price'), 10);
        currencySymbol = $activeProduct.data('formatted-price').replace(/[0-9]+./g, '');
        $menuNext = $menuParentBtn.next().find($menuTrigger);
        thumbPath = $activeProduct.attr('data-medium-img');
        $menuTitle = $menuParentBtn.find($menuTrigger);

        // Set Thumb and Sticky images
        $selectedThumbImg.eq(catagoryIndex).attr('src', thumbPath).parent().addClass('active');
        $stickyImg.eq(catagoryIndex).attr('src', thumbPath).parent().addClass('active');
        $editProdImage.eq(catagoryIndex).attr('src', thumbPath);
        $menuParentBtn.addClass('active-cat');
        $activeProduct.addClass('selected js-kit-selected');
        $addToSetElement.removeClass('active');
        $menuTitle.addClass('active-title');
        $menuNext.trigger('click');

        if ($kitContainer.find('.selected').length === kitCategoryLength) {
          $addToBag.removeClass('button--disabled');
          $selectedProdSmall.addClass('active');
        }

        if (catagoryIndex === kitCategoryLength - 1) {
          $menuParentBtn.removeClass('collapsible-menu__parent--expanded');
        }
        updatePrice();
      });

      $changeProduct.on('click', function () {
        $editElement = $(this);
        $collapsibleMenuIndex = $editElement.parents('.js-kit-edit-list').index();
        $menuTrigger.eq($collapsibleMenuIndex).trigger('click');
        $('html,body').animate(
          {
            scrollTop: $menuTrigger.eq($collapsibleMenuIndex).offset().top
          },
          500
        );
      });
      if (catSoldOut) {
        $defaultImage.removeClass('hidden');
      } else {
        $menuTrigger.first().trigger('click');
      }

      // Add to Kit
      $addToBag.on('click', function () {
        selectedSkuIds = [];
        $selectedItem = $('.js-kit-selected', $kitContainer);
        if ($selectedItem.length !== kitCategoryLength || $addToBag.hasClass('button--disabled')) {
          return false;
        }
        $addToBag.addClass('button--disabled');
        if (defaultSku !== undefined && defaultSku !== '') {
          selectedSkuIds.push(defaultSku);
        }

        $.each($selectedItem, function () {
          $selectedItemElem = $(this);
          skuBaseId = $.trim($selectedItemElem.attr('data-sku-id'));
          if (skuBaseId !== '') {
            selectedSkuIds.push($selectedItemElem.attr('data-sku-base-id'));
          }
        });

        if (kitName !== undefined && kitName !== '') {
          kitName = kitName + ' ';
        } else {
          kitName = Drupal.settings.default_kit_name + ' ';
        }

        args = {};
        args.COLLECTION_TYPE = 'UKIT';
        args.COLLECTION_SUBTYPE = 'CUSTOM_BUNDLE';
        args.SKU_BASE_ID = selectedSkuIds;
        args._SUBMIT = 'alter_collection';
        args.QTY = 1;
        args.COLLECTION_NAME = kitName + Math.floor(Math.random() * 10000);
        args.action = 'add,edit,create_kit';

        args.HAS_MULTIPLE_SKUS = 1;
        if ($.cookie('csrftoken')) {
          args._TOKEN = $.cookie('csrftoken');
        }

        generic.jsonrpc.fetch({
          method: 'rpc.form',
          params: [args],
          onSuccess: function (responseData) {
            resultData = responseData.getData();
            $addToBag.removeClass('button--disabled');
            $(document).trigger('addToCart.success', [resultData]);
          },
          onFailure: function (responseErr) {
            resultData = responseErr.getMessages();
            $document.trigger('addToCart.toggle', [args.$addBtn]);
            $document.trigger('addToCart.failure', [resultData]);
          }
        });
      });
    }
  };
})(jQuery);
